module.exports = __webpack_public_path__ + "static/s102_large-033ff68bb9d6d5448f5d82dd627af36b.jpg";